import { Component, inject, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'member-toggle-dialog.component',
  templateUrl: './member-toggle-dialog.component.html',
  styleUrl: './member-toggle-dialog.component.scss',
})
export class MemberToggleComponent {
  public oldPartyName: string = '';
  public newPartyName: string = '';
  public dialogRef: MatDialogRef<MemberToggleComponent> = inject(MatDialogRef);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.oldPartyName = data.oldPartyName;
    this.newPartyName = data.newPartyName;
  }

  public confirm(value: boolean): void {
    this.dialogRef.close(value);
  }
}
